import {FeatureValues} from "../order/order";
import {Backside, Material} from "../catalog/catalog.model";

export class CalculationResponse {
  constructor(
    readonly backSide?: Backside,
    readonly material?: Material,
    readonly features: FeatureValues = {},
    readonly optional?: string
  ){}
}

export class CalculationRequest {
  trialLens: {
    backSideId?: number,
    materialId?: number,
    features?: FeatureValues
  };
  overRefraction: {
    features?: FeatureValues
  };
  newParameter: {
    materialId?: number,
    features?: FeatureValues
  }

  constructor() {
    this.trialLens = {
      features: {}
    };
    this.overRefraction = {
      features: {}
    };
    this.newParameter = {
      features: {}
    };
  }
}
